(function () {
    //focus using tab key
    var clickCounter = 0;
    $('body')
        .keyup(function (e) {
            var code = e.keyCode || e.which;
            if (code === 9 || code === 32 || code === '13') {
                $('.acs-focus').removeClass('acs-focus');
                $(':focus').addClass('acs-focus');
            }

            if (code === 32 && $(':focus').hasClass('read-less')) {
                ++clickCounter;
                if (clickCounter >= 2) {
                    clickCounter = 0;
                    setTimeout(function () {
                        $('.acs-focus').removeClass('acs-focus');
                    }, 200);
                }
            }
        })
        .click(function () {
            $('.acs-focus').removeClass('acs-focus');
        });

    $(window).scroll(function () {
        var isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;
        var $el, scrollTop, scrollBot, elTop, elBottom, visibleTop, visibleBottom;

        if (!isMobile) {
            calcStickyTabPosition();
            if ($('.styleguide-toc-rightTab').length > 0) {
                $stickyQVHeader = new Waypoint({
                    element: $('.styleguide-toc-page')[0],
                    handler: function ($direction) {
                        if ($direction === 'down') {
                            $el = $('.styleguide-toc-page');
                            scrollTop = $(window).scrollTop();
                            scrollBot = scrollTop + $(window).height();
                            elTop = $el.offset().top;
                            elBottom = elTop + $el.outerHeight();
                            visibleTop = elTop < scrollTop ? scrollTop : elTop;
                            visibleBottom = elBottom > scrollBot ? scrollBot : elBottom;

                            $('.styleguide-toc-rightTab').addClass('styleguide-toc-rightTab-sticky');
                            $('.styleguide-toc-rightTab').css({
                                marginTop: 24 + 'px',
                                right: '40px',
                                top: '110px',
                                height: visibleBottom - visibleTop - 150,
                            });
                        } else if ($direction === 'up') {
                            $el = $('.styleguide-toc-page');
                            scrollTop = $(window).scrollTop();
                            scrollBot = scrollTop + $(window).height();
                            elTop = $el.offset().top;
                            elBottom = elTop + $el.outerHeight();
                            visibleTop = elTop < scrollTop ? scrollTop : elTop;
                            visibleBottom = elBottom > scrollBot ? scrollBot : elBottom;

                            $('.styleguide-toc-rightTab').removeClass('styleguide-toc-rightTab-sticky');
                            $('.styleguide-toc-rightTab').css({
                                marginTop: '24px',
                                right: '40px',
                                top: 'auto',
                                height: visibleBottom - visibleTop - 150,
                            });
                        }
                    },
                    offset: 94,
                });
            }
        }
    });

    calcStickyTabPosition = function () {
        var hT, wH, wS;

        if ($('.styleguide-toc-rightTab').length > 0) {
            hT = $('.footer').offset().top;
            wH = $(window).height();
            wS = $(window).scrollTop();
            if (wS > hT - wH) {
                if (
                    Math.abs(wH - (Math.abs(hT - wH - wS) + $('.styleguideHeader').height())) <
                    $('.styleguide-toc-rightTab').height()
                ) {
                    $('.styleguide-toc-rightTab').css('bottom', Math.abs(hT - wH - wS));
                    $('.styleguide-toc-rightTab').addClass('rightTabStickyBottomClass');
                }
            } else {
                $('.styleguide-toc-rightTab').css('bottom', 'auto');
                $('.styleguide-toc-rightTab').removeClass('rightTabStickyBottomClass');
            }
        }
    };

    //scroll to specific element id
    scrollToSpecificElementId = function (elementId) {
        var $hashElement = $('#' + elementId);
        var $header = $('header.header');
        if ($hashElement.length > 0) {
            $('html, body').animate(
                {
                    scrollTop: $hashElement.offset().top - $header.height(),
                },
                100
            );
        }
    };

    //scroll to specific element with class
    scrollToSpecificElementWithClass = function scrollToSpecificElementWithClass(className) {
        var $header = $('header.header');

        scrollToSpecificElementWithClassImpl(className, $header.height());
    };

    scrollToSpecificElementWithClassImpl = function (className, headerHeight) {
        var $hashElement = $('.' + className);

        if ($hashElement.length > 0) {
            $('html, body').animate(
                {
                    scrollTop: $hashElement.offset().top - headerHeight,
                },
                1000
            );
        }
    };

    //Freeze Page
    freezePage = function () {
        $('body').addClass('acs_freeze-page');
    };

    unfreezePage = function () {
        $('body').removeClass('acs_freeze-page');
    };

    // Ajax Overlay
    ajaxOverlay = function (element) {
        $(element).addClass('acs_ajaxOverlay');
    };

    removeAjaxOverlay = function (element) {
        $(element).removeClass('acs_ajaxOverlay');
    };

    scrollToElement = function (pos, idName) {
        var headerHeight;
        var scrollDuration = 15;

        if ($('header.header').length > 0) {
            if ($('.header_article').length > 0) {
                if (idName === '#Abstract') {
                    pos = $('.article_abstract').offset().top;
                }
            }

            headerHeight = $('header.header').height() + 10;

            if ($(this).attr('data-scrollDuration')) {
                scrollDuration = 1000;
            }

            $('html,body').animate(
                {
                    scrollTop: pos - headerHeight,
                },
                scrollDuration
            );
        }
    };

    // initLazyLoading = function(){
    //     $("img.lazy").lazyload();
    // };

    /*
     * Returns a function, that, as long as it continues to be invoked, will not
     * be triggered. The function will be called after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     */
    debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i,
            returnVal = '';

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                if (returnVal !== '') {
                    returnVal += sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                } else {
                    returnVal = sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
        }
        return returnVal;
    };
})();
